module.exports = __webpack_public_path__ + "static/media/02.70a5dde4.png";